import { getInstance } from '../getInstance/getInstance';
export function getDecodedInstance(_ref) {
  let {
    wixCodeApi,
    appParams
  } = _ref;
  const instance = getInstance({
    wixCodeApi,
    appParams
  });
  if (!instance) {
    return null;
  }
  const encodedInstance = instance.substring(instance.indexOf('.') + 1);
  return JSON.parse(decodeBase64(encodedInstance));
}
function decodeBase64(str) {
  if (typeof atob !== 'undefined') {
    return atob(str);
  }
  return '{}';
}
//# sourceMappingURL=getDecodedInstance.js.map